export const br = {
	locale: 'pt-br',
	yes: 'Sim',
	not: 'Não',
	report_title: 'Relatórios',
	number: 'Número',
	month_select: 'Selecione o Mês',
	monthly: 'Mensal',
	month: 'mês',
	year: 'ano',
	biennial_unit: '2 anos',
	outted: 'Saída',
	inner: 'Entrada',
	add_new_number: 'Adicionar novo número',
	edit_number_meta: 'Trocar número',
	amount_of_actived_numbers:
		'Números {avaliableToActive, plural, one {disponivel} other {disponiveis}} {actived}/{avaliableToActive}',
	amount_of_numbers_new_plan:
		'Números utilizados: PRO {active_pro}/{total_pro} BASIC: {active_basic}/{total_basic}',
	amount_of_numbers_pro: 'Números utilizados: PRO {active_pro}/{total_pro}',
	amount_of_numbers_basic: 'Números utilizados: BASIC {active_basic}/{total_basic}',
	actives: 'Ativos',
	inactives: 'Inativos',
	inactive: 'Inativo',
	numbers_title: 'Lista de números',
	pro_numbers_title: 'Lista de números PowerZap',
	plan_limit: 'Você atingiu o limite do seu plano',
	basic_numbers_title: 'Lista de números Basic',
	just_left: 'Próximo pagamento em',
	subscription_title: 'Assinatura',
	renew: 'Renovar',
	renew_now: 'Renovar agora',
	day: '<b>{day, plural, one {# dia} other {# dias}}</b>',
	connected_channels_title: 'Canais conectados',
	terms_of_use_title: 'Termos de uso',
	terms_of_use_conditions: 'Condições de processamento de dados pessoais',
	terms_of_use_secure: 'Politica de privacidade',
	update_list_title: 'Atualizações',
	last_update_title: 'Últimas atualizações',
	last_update_system_version: 'Versão atual do sistema',
	see_more: 'Ver mais',
	last_update_your_version: 'Sua versão atual',
	edit: 'Editar',
	unlink_channel: 'Desvincular Canal',
	link_channel: 'Vincular Canal',
	delete: 'Deletar',
	clear_queue: 'Limpar fila',
	add_numbers_title: 'Adicionar novo número',
	add_pro_numbers_title: 'Adicionar novo número PowerZap',
	create_pro_trial: 'Testar número PowerZap',
	add_basic_numbers_title: 'Adicionar novo número Basic',
	api_connected: 'Status',
	edit_numbers_title: 'Editando número: {number}',
	numbers_form_nickname: 'Apelido',
	form_msg_nickname: 'OPS, Você não escolheu o apelido',
	numbers_form_api: 'Escolha a API',
	form_msg_api: 'OPS, Você não escolheu a api',
	numbers_form_token: 'TOKEN do Integrador',
	form_msg_token: 'OPS, Você não digitou o token da API',
	numbers_form_account: 'ID da Instância/ID da Conta',
	form_msg_account: 'OPS, Digite ID da Instância ou ID da Conta',
	numbers_form_namespace: 'Namespace do canal',
	form_msg_namespace: 'Ops, digite o namespace do canal',
	numbers_form_country: 'País de origem',
	numbers_form_openai_token: 'Digite seu token da API OpenAI',
	msg_error_openai_token:
		'Número salvo com sucesso, mas ocorreu um problema ao salvar as configurações da OpenAI. Tente novamente.',
	form_country: 'País de origem',
	steps_form_country: 'País de origem',
	form_msg_country: 'OPS, Você deve inserir  o seu país de origem',
	form_is_national: 'Origem dos contatos',
	form_msg_is_national: 'OPS, Você deve inserir se você possui apenas contatos nacionais.',
	numbers_form_phone_number: 'Número do celular',
	form_msg_phone_number: 'OPS, Digite o número do celular',
	form_msg_channel_id: 'OPS, Digite o Channel ID',
	steps_form_channel: 'Canais',
	steps_form_phone_number: 'OPS, Digite o número do celular',
	steps_form_namespace: 'Namespace do canal',
	form_status: 'Status do dispositivo',
	form_msg_status: 'OPS, Você esqueceu de marca se seu dispositivo está online ou offline',
	additional_settings: 'Configurações adicionais',
	audio_transcription: 'Transcrição de áudio',
	audio_transcription_column: 'Transcrição',
	form_msg_audio_transcription: 'Por favor, selecione uma opção de transcrição de áudio',
	enabled: 'Ativada',
	disabled: 'Desativada',
	openai_token: 'Token OpenAI',
	form_msg_openai_token: 'Por favor, insira um token OpenAI válido',
	link_channel_title: 'Vincular canal',
	link_form_channel: 'Escolha o Canal',
	link_channel_success: 'Canal vinculado com sucesso!',
	link_channel_error: 'Erro ao vincular canal',
	unlink_channel_success: 'Canal desvinculado com sucesso!',
	unlink_channel_error: 'Erro ao desvincular canal',
	unlink_channel_msg: 'Você tem certeza que deseja desvincular esse canal ',
	clear_queue_msg:
		'Você tem certeza que deseja limpar a fila? Isso cancelará todas as mensagens que foram enviadas a partir do Bitrix24 enquanto o número estava desconectado.',
	number_of_messages_on_queue: 'Número de mensagens na fila: ',
	delete_msg: 'Você tem certeza que deseja deletar ',
	placeholder_search_address: 'Buscar endereço',
	loading_map: 'Carregando mapa...',
	map_load_error: 'Não foi possível carregar o mapa.',

	// Marketing Campaign
	status_tooltip:
		'O status da mensagem do WhatsApp (entregue e lido) depende das configurações de privacidade do contato.',
	write_your_campaign_message: 'Escreva a mensagem da sua campanha',
	write_your_message_here: 'Escreva sua mensagem aqui',
	upload_file_max_size: 'O tamanho máximo de arquivo permitido pela Meta é 100MB',
	select_variable: 'Selecione uma variável',
	new_campaign: 'Nova Campanha',
	search: 'Pesquisar',
	send_manually: 'Enviar manualmente',
	campaign_name: 'Nome da Campanha',
	scheduled_for: 'Agendado para',
	reschedule: 'Reagendar',
	campaign_reschedule: 'Reagendar envio da campanha',
	reschedule_message_success: 'Campanha reagendada com sucesso!',
	reschedule_message_error: 'Erro ao reagendar campanha.',
	remaining_time: 'Tempo restante',
	sent: 'Enviado',
	delivered: 'Entregue',
	read: 'Lido',
	failed: 'Falhou',
	error: 'Erro',
	status_pending: 'Pendente',
	start_sending_now: 'Enviar agora',
	view_campaign_items: 'Ver detalhes',
	destination_number: 'Número de destino',
	message_status: 'Status da mensagem',
	message_success: 'Mensagem enviada com sucesso.',
	campaign_not_send: 'A campanha não foi enviada por estar fora do horário comercial.',
	campaign_not_send_openline:
		'A campanha não foi enviada, pois não foi possível verificar o horário de trabalho no Bitrix24.',
	description_status: 'Descrição',
	delete_campaign_confirmation:
		'Tem certeza de que deseja excluir esta campanha? Essa ação não pode ser desfeita e cancelará imediatamente a execução da campanha.',
	of: 'de',
	finished: 'Concluído',
	awaiting_start: 'Aguardando início',
	queued: 'Enfileirado',
	estimating: 'Estimando',
	less_than_a_minute: 'Menos de um minuto',
	hour: 'hora',
	minute: 'minuto',
	and: 'e',
	set_campaign_name: 'Defina o nome da campanha',
	campaign_name_placeholder: 'Nome da campanha',
	deal: 'Negócio',
	contact: 'Contato',
	lead: 'Lead',
	company: 'Empresa',
	field_required: 'Campo obrigatório',
	configure_segment: 'Configure o segmento que deseja enviar a campanha',
	define_campaign_segment: 'Defina o segmento da campanha',
	segment_name: 'Nome do segmento',
	conditionals: 'Condicionais',
	bigger_than: 'Maior que',
	smaller_than: 'Menor que',
	equal_to: 'Igual a',
	different_from: 'Diferente de',
	bigger_or_equal_to: 'Maior ou igual a',
	smaller_or_equal_to: 'Menor ou igual a',
	contains: 'Contém',
	add_field: 'Adicionar campo',
	segment_user_search_placeholder: 'Usuário (lista ao abrir; filtre pelo nome)',
	required_campaign_name: 'O nome da campanha é obrigatório',
	required_source_number: 'O número de origem é obrigatório',
	required_audience: 'A audiência é obrigatória',
	required_segment: 'O segmento é obrigatório',
	required_message: 'A mensagem é obrigatória',
	required_template: 'O template é obrigatório',
	required_parameters: 'Os parâmetros são obrigatórios',
	required_send_when: 'Quando enviar é obrigatório',
	required_send_date: 'A data de envio é obrigatória',
	name: 'Nome',
	audience: 'Audiência',
	message: 'Mensagem',
	finish: 'Finalizar',
	saving: 'Salvando',
	save: 'Salvar',
	all_contacts: 'Todos os contatos',
	all_companies: 'Todas as empresas',
	all_leads: 'Todos os leads',
	all_deals: 'Todos os negócios',
	all_base: 'Toda a base',
	deals: 'Negócios',
	contacts: 'Contatos',
	companies: 'Empresas',
	define_campaign_audience: 'Defina a audiência da campanha',
	source_number: 'Número de origem',
	select_source_number: 'Selecione o número de origem',
	select_audience_type: 'Selecione o tipo de audiência',
	static_list: 'Lista estática',
	dynamic_list: 'Lista dinâmica',
	custom_recipients:
		'Lista de destinatários personalizados, separados por vírgula ou por quebra de linha. Ex: 5511999999999, 5511999999999 ou \n5511999999999\n5511999999999',
	select_segments: 'Selecione os segmentos',
	segment_filters: 'Filtros de segmento',
	select_campaign_template: 'Selecione o template da campanha',
	choose_variables: 'Escolha entre as variáveis disponíveis ou digite o valor manualmente',
	campaign_ready_1: 'A campanha',
	campaign_ready_2: 'está pronta para ser enviada!',
	campaign_worktime_title: 'Enviar campanhas somente durante o horário comercial',
	campaign_worktime_tooltip: 'Envios fora do horário comercial serão reagendados automaticamente.',
	when_to_send: 'Quando você deseja enviar?',
	now: 'Agora',
	later_manually: 'Depois, manualmente',
	schedule: 'Agendar',
	saving_campaign: 'Salvando campanha...',
	campaign_ready_title: 'Sua campanha está pronta!',

	// Campaign translations
	campaign_title: 'Lista de números associados à campanhas de marketing',
	delete_campaign_warning:
		'Há uma campanha em andamento para este número, ao removê-lo ela será excluída também',
	clear_campaign_queue: 'Você tem certeza que deseja limpar a fila de campanhas de ',
	clear_campaign_queue_success: 'Fila de campanhas deletada com sucesso!',
	clear_campaign_queue_error: 'OPS! Não foi possível deletar a fila de campanhas desse número.',
	total_campaign: 'Mensagens na fila',
	update_campaign: 'Atualizar',
	cancel_campaign: 'Limpar fila',
	create_campaigns:
		'Aprenda a criar campanhas de marketing no Bitrix24 utilizando o PowerZap! {link}',
	send_only_during_work_hours: 'Enviar apenas no horário de trabalho',
	confirm_notification_noLinkedChannel:
		'O número configurado não está vinculado a nenhum canal aberto. Nesse caso, não há um horário de atendimento a ser considerado e as mensagens serão enviadas a qualquer momento.',
	confirm_notification_worktimeDisabled:
		'O canal aberto ao qual o número está conectado não tem um horário de atendimento definido. Nesse caso, a opção será desconsiderada e as mensagens serão enviadas a qualquer momento.',

	work_hours_defined_in_bitrix24_channel:
		'Horário de trabalho definido no canal aberto do Bitrix24, do número em questão.',
	click_here_to_configure: 'Clique aqui para configurar.',
	clear_queue_immediately: 'Limpar fila imediatamente',
	settings: 'Configurações',

	last_update_version: 'Relatório de atualização - Versão {version}',
	api: 'API',
	actions: 'Ações',
	clear_queue_success: 'Fila limpa!',
	clear_queue_error: 'Erro ao limpar a fila',
	delete_number_success: 'Número deletado com sucesso!',
	delete_number_error: 'OPS! Não foi possivel deletar seu número',
	not_found_registers: 'Não foram encontrados registros!',
	alert_audio:
		'ATENÇÃO: Envio de áudio ou anexo deve ser feito somente para CONVERSAS EM ANDAMENTO. Enviar áudio ou anexo para iniciar novas conversas, pode causar o BLOQUEIO do seu número!',
	toggle_mbird: 'Deseja enviar aúdio ou anexo para algum número com conversa ativa?',
	new: 'Novo',
	online: 'Ligado',
	offline: 'Desligado',
	channel_name: 'Nome do canal aberto',
	edit_number_success: 'Número editado com sucesso!',
	add_number_success: 'Número adicionado com sucesso!',
	tutorials_title: 'Tutoriais',
	all_numbers: 'Todos os números',
	step_one: 'Boas Vindas',
	step_two: 'Integrador',
	step_three: 'Configurando',
	step_four: 'Dispositivo',
	step_five: 'Pronto',
	step_six: 'Webhook',
	step_seven: 'Canal Aberto',
	choice_title: 'Como você gostaria de se conectar?',
	choice_subtitle: 'Escolha a opção que faz mais sentido para o seu momento.',
	choice_qr_title: 'Conexão direta',
	choice_qr_b1: 'Sem custo por conversa',
	choice_qr_b2: 'Conexão rápida, direto pelo WhatsApp',
	choice_qr_b3: 'Bom para o dia a dia do atendimento',
	choice_qr_b4: 'Uso contínuo até escala moderada',
	choice_qr_highlight: 'Indicado para começar a atender rápido',
	choice_meta_title: 'API oficial (Meta)',
	choice_meta_b1: 'Cobrança por conversa iniciada. <link>Saiba mais</link>',
	choice_meta_b2: 'Precisa passar pela aprovação da Meta',
	choice_meta_b3: 'Sem limite técnico de envio',
	choice_meta_b4: 'Pensada para operações maiores',
	choice_meta_highlight: 'Times que já profissionalizaram o atendimento',
	qr_title: 'Conecte seu número de WhatsApp',
	qr_subtitle: 'Escaneie o QR Code para começar a atender pelo WhatsApp direto no Bitrix24.',
	qr_before: 'Antes de escanear:',
	qr_step_1: 'Abra o WhatsApp no seu celular.',
	qr_step_2:
		'Toque nos três pontinhos (ou no ícone de configurações) e acesse "Aparelhos conectados".',
	qr_step_3: 'Escaneie o QR Code ao lado.',
	qr_after: 'Depois de escanear, <b>aguarde o carregamento da sua sessão.</b>',
	qr_expired: 'O código expirou',
	qr_regenerate: 'Gerar QR Code novamente',
	qr_loading: 'Preparando seu QR Code',
	qr_loading_hint: 'Isso pode levar alguns segundos.',
	connected_title: 'Número conectado com sucesso!',
	connected_subtitle:
		'Agora, vamos vincular esse número a um Canal Aberto para começar a receber mensagens.',
	final_title: 'Tudo certo! Seu PowerZap está configurado',
	final_subtitle:
		'Você já pode ver a conversa no Bate-papo ou configurar os Canais Abertos no Bitrix24 para organizar sua equipe.',
	final_cta_bitrix: 'Configurar canais no Bitrix24',
	final_cta_chat: 'Ir para Bate-papo',
	pz_notice:
		'O número fica associado ao canal selecionado aqui no Powerzap. No Bitrix24, confirme se há agentes e permissões configurados.',
	pz_notice_link: 'Saiba como configurar seu PowerZap no Bitrix24 <link>clicando aqui</link>.',
	channel_title: 'Escolha o Canal Aberto do Bitrix24 para vincular este número',
	channel_subtitle:
		'As mensagens desse número serão distribuídas entre os atendentes do canal selecionado.',
	channel_count: '{count, plural, one {{padded} Canal Aberto} other {{padded} Canais Abertos}}',
	choice_footer:
		'Ainda tem dúvidas sobre como se conectar? <link>Clique aqui</link> para mais informações.',
	to_start: 'Agora que você baixou nosso conector, selecione um dos integradores disponíveis',
	what_is_integrator:
		'OBS: Integrador é a plataforma que ira fazer o serviço de envio de mensagens',
	with_base: 'Com base na imagem ao lado',
	type_token: 'Digite o Token',
	type_device_id: 'Digite o ID do Dispositivo/ID da Conta',
	type_namespace: 'Digite o Namespace do Canal',
	steps_form_account: 'ID do Dispositivo ou conta',
	select_country: 'Qual é seu país de origem?',
	type_number: 'Diga-nos o número do telefone que usará para enviar mensagens.',
	agree0: 'Envie mensagens',
	agree_desc0: 'Notifique seus leads ou clientes diretamente das entidades do Bitrix24.CRM',
	agree1: 'Receba mensagens',
	agree_desc1: 'Conecte o Whatsapp aos canais abertos e tenha todas as funcionalidades nativas',
	agree2: 'Distribua contatos',
	agree_desc2: 'Com apenas um número de Whatsapp você pode distribuir as conversas para sua equipe',
	agree3: 'Automatize',
	agree_desc3:
		'Você pode configurar regras ilimitadas para envio de mensagens automáticas no Bitrix24',
	all_done: 'Parabéns! Viu como foi fácil!',
	done: 'Ir para o APP',
	previous: 'Anterior',
	next: 'Próximo',
	continue_configuration: 'Continuar configuração',
	meta_connect_subtitle: 'Você será redirecionado para a página de conexão com a Meta.',
	meta_connect_intro: 'Mantenha sua conta protegida durante a conexão com a API oficial da Meta:',
	meta_connect_step_1: 'Não conecte o mesmo número a nenhuma outra plataforma via API não oficial.',
	meta_connect_step_2: 'Verifique sua empresa na Meta. <link>Acesse aqui</link>',
	meta_connect_step_3: 'Adicione um método de pagamento válido na Meta. <link>Acesse aqui</link>',
	meta_connect_step_4: 'Tenha pelo menos um modelo de mensagem aprovado. <link>Acesse aqui</link>',
	meta_connect_error_title: 'Falha na conexão',
	meta_connect_error_description:
		'Verifique se as informações da sua conta Meta estão de acordo e tente novamente.',
	meta_connecting: 'Conectando seu número…',
	meta_connect_retry: 'Tentar novamente',
	choice_pro_only: 'Disponível para assinantes PRO',
	choice_upgrade: 'Upgrade',
	channel_load_error: 'Não foi possível carregar os dados dos Canais Abertos.',
	channel_empty:
		'Nenhum Canal Aberto encontrado no seu Bitrix24. Crie um Canal Aberto e atualize a lista para continuar.',
	channel_create: 'Criar Canal Aberto no Bitrix24',
	channel_reload: 'Atualizar lista',
	meta_connect_error_interrupted:
		'A conexão com a Meta falhou ou foi interrompida. Tente novamente.',
	skip: 'Pular passo a passo',
	confirm_skip: 'Deseja realmente pular o tutorial de configuração?',
	billing_point1: 'Integração com canais abertos',
	billing_point2: 'Envio de mensagem pelo CRM',
	billing_point3: 'Regra de automação exclusiva',
	billing_point4: 'Escolha dentre várias APIs',
	billing_point5: 'Suporte ilimitado',
	billing_point6: 'Até 20.000 mensagens trocadas por mês',
	free_test: 'Teste Grátis',
	from_price: 'a partir de',
	discount: 'de desconto',
	annualy: 'anual',
	subscription: 'Assinatura',
	add_subscription_error: 'Houve um erro ao ativar o trial.',
	add_number_error: 'Não foi possível salvar o número, verifique os dados informados.',
	add_number_api_empty: 'Api não selecionada!',
	actual_month: 'Mês atual',
	last_month: 'Mês passado',
	subscription_expired_msg: 'Sua assinatura expirou, verifique a área de assinatura!.',
	national: 'Nacional',
	not_national: 'Nacional/Internacional',
	not_done_yet: 'Estamos quase lá! Falta apenas um passo.',
	not_done_yet2: 'Você precisa configurar o webhook agora, vamos lá!',
	not_done_yet3: 'Siga o seguinte tutorial:',
	not_done_yet4: 'Esse número que está vinculando será para o canal: ',
	subscription_expired: 'Assinatura expirou, tente renová-la agora!.',
	try_send: 'Para testar seu aplicativo, tente enviar uma mensagem abaixo',
	first_message_title: 'Envie sua primeira mensagem',
	first_message_subtitle: 'Teste seu aplicativo enviando uma mensagem agora mesmo!',
	first_message_preview: 'Teste seu aplicativo enviando uma mensagem agora mesmo!',
	first_message_default: 'Olá! Essa é uma mensagem de teste direto do PowerZap.',
	first_message_send: 'Enviar mensagem',
	first_message_to_placeholder: 'Adicione um número para testar',
	first_message_to_add: 'Adicionar número',
	first_message_notify:
		'Sua mensagem de teste foi enviada pelo PowerZap! Quando o número de teste responder, a conversa aparece no Bate-papo.',
	first_message_select_template: 'Selecione o template de mensagem',
	first_message_templates_error:
		'Não foi possível carregar os templates de mensagem. Verifique se há pelo menos um modelo de mensagem cadastrado na sua conta Meta.',
	first_message_channel_error:
		'Não foi possível enviar sua mensagem. Verifique se o seu Canal Aberto está configurado e tente novamente.',
	first_message_send_error: 'Não foi possível enviar sua mensagem.',
	select_destination: 'Selecione o número de destino',
	type_your_msg: 'Digite sua mensagem',
	send_msg: 'Enviar',
	files_text1_mobile: 'Clique para fazer o upload',
	files_text1: 'Clique ou arraste o arquivo para esta área para fazer o upload',
	files_text2: 'Suporte para um upload único',
	file_type: 'Somente arquivos jpg, png, pdf são suportados',
	send_message_success: 'Mensagem enviada',
	send_message_error: 'Erro ao enviar mensagem',
	send_message_unexpected_error:
		'Ocorreu um erro inesperado ao enviar a mensagem, por favor contate o nosso time de suporte',
	url_signature_expired: 'URL da mídia expirou. Atualize a URL nas configurações do template.',
	empty_parameters: 'Preencha todos os parâmetros do template.',
	location_required: 'Preencha o campo de localização do template.',
	back: 'Voltar',
	current: 'Atual',
	select: 'Selecionar',
	hello: 'Olá {name} :)',
	have_update: 'Seu aplicativo possui atualizações.',
	have_update_button: 'Atualizar agora!',
	updated_successfull: 'Updated sucessfully',
	updated_error: 'Update error',
	welcome: 'Parabéns!',
	welcome_title: 'Que bom ter você aqui!',
	welcome_subtitle: 'Vamos conectar seu WhatsApp?',
	welcome2: 'Você acaba de instalar o melhor conector de Whatsapp do Bitrix24',
	welcome3: 'e está a poucos passos de escalar seu atendimento com o Whatsapp.',
	example_number:
		'Exemplo: 554499999999, 55 significa  o código do país, 44 é o DDD, restante é o número do telefone',
	oficial: 'API Oficial',
	not_oficial: 'API Não Oficial',
	oficial_twilio:
		'IMPORTANTE: \n    Twilio é uma integrador de API Oficial do Whatsapp, \n    com isso para contratação é necessário solicitar aprovação do número junto ao Facebook (proprietário do Whatsapp). \n    Este período de aprovação leva em médio 30 dias. \n  Caso não deseje esperar este período, contrate outro integrador e faça uso do aplicativo imediatamente. \n Basta voltar no passo anterior e selecionar o Integrador que mais se encaixa na sua necessidade.',
	zapbox_desc:
		"Para configurar seu número, é necessário que você já tenha contratado um plano e ativado a conta no Zapbox.    Caso ainda não tenha feito, acesse o painel do Zapbox e ative seu número <a target='_blank' href='https://whatsweb.app/account/login'> (Clique aqui para acessar)</a>",
	twilio_desc:
		'IMPORTANTE: \n    Twilio é uma integrador de API Oficial do Whatsapp, \n    com isso para contratação é necessário solicitar aprovação do número junto ao Facebook (proprietário do Whatsapp). \n    Este período de aprovação leva em médio 30 dias. \n  Caso não deseje esperar este período, contrate outro integrador e faça uso do aplicativo imediatamente. \n Basta voltar no passo anterior e selecionar o Integrador que mais se encaixa na sua necessidade.',
	not_oficial_desc:
		'Integradores não oficiais. Nosso conector não possui vínculo com os integradores. Para mais informações acesse as Políticas de Privacidade e Termos de Uso.',
	open_channel:
		"Os Canais Abertos do Bitrix24 coletam mensagens de todos os canais de comunicação com os clientes e distribuem-nas entre os agentes da fila. <br> <br>Para saber mais sobre os Canais Abertos <a target='_blank' href='https://helpdesk.bitrix24.com.br/open/9612023/'> (Clique aqui para acessar)</a>",
	time_left: 'Restam {days, plural, one {# dia} other {# dias}} para expirar seu trial',
	subscription_error_warning:
		'Parece haver um erro com a sua assinatura, verifique com o administrador',
	cancel: 'Cancelar',
	subscription_limit_msg: 'Você excedeu o limite de números permitido pelo plano.',
	msg_empty: 'O Corpo da mensagem não pode ser vazia.',
	params_empty: 'As caixas de texto não podem estar vazias',
	to_empty: 'Destino não pode ser vazio.',
	from_empty: 'Origem não pode ser vazia.',
	sending_message: 'Enviando mensagem...',
	promotion_title: ' Escale os resultados da sua empresa com WhatsApp + Chat Booster',
	promotion_text1: ' Aumento de ROI',
	promotion_text2: ' Priorização de atendimento',
	promotion_text3: ' Geração de Oportunidades 24h',
	promotion_text4: ' Automtização de respostas para cada perfil de cliente',
	promotion_text5: ' Qualifição de leads',
	promotion_text6: ' Benefícios de ponta a ponta, do Marketing ao Pós-venda',
	try_now: 'Teste Grátis Agora!',
	dont_show_again: 'Não mostrar novamente',
	close: 'Fechar',
	number_empty: 'Número está vazio!',
	token_empty: 'Token está vazio!',
	device_id_empty: 'ID da conta está vazio!',
	namespace_empty: 'Namespace está vazio!',
	api_empty: 'Escolha uma api!',
	under_maintenance: 'Módulo de Relatórios desabilitado momentaneamente para atualização',
	know_you_better: 'Queremos te conhecer melhor!',
	prioritize_your_resources: 'Assim, podemos priorizar recursos essenciais para você!',
	full_name: 'Nome completo',
	enterprise_website: 'Website da empresa',
	email: 'E-mail',
	email_error: 'Por favor digite um e-mail válido',
	enterprise_phone: 'Telefone/WhatsApp',
	enterprise_phone_error: 'Por favor digite um telefone válido',
	country: 'País',
	send: 'Enviar',
	lead_status: 'Status',
	deal_category: 'Funil',
	deal_stage: 'Fase',
	from_number: 'Número de origem',
	to_numbers: 'Números de destino',
	to_number: 'Número de destino',
	log_messages: 'Histórico de Mensagens',
	date: 'Data',
	message_count: 'Total de mensagens trocadas no mês',
	message_in: 'Recebidas',
	message_out: 'Enviadas',
	message_total: 'Total de mensagens no mês',
	warning_message_count:
		'Agora você pode acompanhar a quantidade de mensagens trocadas durante o mês!',
	warning_amount_numbers:
		'Agora você não precisa se preocupar com a quantidade de números disponíveis!',
	custom_made_plan_title: 'Personalize seu plano',
	custom_made_plan_body:
		'Envie + de 20.000 mensagens/mês em um plano feito sob medida para a sua empresa',
	custom_made_plan_button: 'Solicitar Orçamento',
	record_audio_tooltip: 'Gravar Áudio',
	play_audio_tooltip: 'Reproduzir áudio',
	discard_audio_tooltip: 'Descartar áudio',
	attach_audio_tooltip: 'Anexar áudio',
	recording_audio: 'Gravando...',
	reports_leads_title: 'LEADS WHATSAPP',
	reports_leads_title_warning: 'Lembre-se que este relatório é referente ao período informado!',
	reports_deals_title: 'NEGÓCIOS WHATSAPP',
	reports_deals_title_warning: 'Lembre-se que este relatório é referente ao período informado!',
	data_picker: 'Periodo dos relatórios',
	percent_leads: 'Percentual de Leads',
	percent_warning: 'Gerados pelo Whatsapp em relação ao total, no período selecionado.',
	percent_deals: 'Percentual de Negócios',
	chart_ticket: 'Ganhos mensais de Negócios gerados pelo Whatsapp',
	reports_ticket_title_warning: 'Lembre-se que este relatório é referente ao período informado!',
	deals_op_warning: 'Lembre-se que este relatório é referente ao período informado!',
	deals_op: 'Valor total dos negócios gerados pelo Whatsapp',
	dashboard_tab_title: 'PAINEL DE CONTROLE',
	permissions_tab_title: 'PERMISSÕES',
	billing_central_tab_title: 'CENTRAL DE PAGAMENTO',
	marketing_campaigns_tab_title: 'CAMPANHAS DE MARKETING',
	help_tab_title: 'AJUDA',
	data_picker_gerar: 'Gerar relatórios',
	message_count_warning_title: 'Aviso!',
	message_count_warning_message: 'Dados de relatório temporariamente indisponíveis!',
	image_banner: 'banner_esignature_pt.jfif',
	try_now_month: 'Quero o Plano Mensal!',
	try_now_year: 'Quero o Plano Anual!',
	choose_an_integrator: 'Escolha um integrador para prosseguir',

	leads: 'Leads',
	won: 'Ganhos',
	in_progress: 'Em Andamento',
	lost: 'Perdidos',
	converted: 'Convertidos',
	monthly_profit: 'Ganhos Mensais',
	month_0: 'Janeiro',
	month_1: 'Fevereiro',
	month_2: 'Março',
	month_3: 'Abril',
	month_4: 'Maio',
	month_5: 'Junho',
	month_6: 'Julho',
	month_7: 'Agosto',
	month_8: 'Setembro',
	month_9: 'Outubro',
	month_10: 'Novembro',
	month_11: 'Dezembro',
	open_channels: 'Canais Abertos',
	open_channels_text: 'Os dados apresentados são referentes aos seguintes canais abertos:',
	open_channels_tooltop:
		'Para mostrar dados de outro canal aberto do WhatsApp, faça o vínculo do canal aberto a algum número na aba PAINEL DE CONTROLE',
	open_channels_empty: 'Vincule um canal aberto ao WhatsApp para receber dados de relatório!',
	trial_left: 'Seu período de teste grátis irá terminar em',
	trial_final_1: 'Seu período de teste está acabando! Restam apenas ',
	trial_final_2: 'Escolha seu plano de assinatura ou <a>clique aqui</a> para receber ajuda.',
	on_hold_message: 'Atualize os dados do seu cartão para continuar utilizando o aplicativo.',
	active_left: 'Sua assinatura será renovada automaticamente em',
	alert_title: 'Erro na Autenticação',
	alert_message:
		'Para que o processo de autenticação ocorra corretamente é necessário que um usuário com permissões de administrador acesse o aplicativo.',
	template: 'Selecione o template',
	template_title: 'Template (desabilitado em caso de audio ou arquivo)',
	template_error: 'Erro ao buscar template',
	template_fetch_permission_error:
		'As permissões de acesso à sua Conta Comercial do WhatsApp podem ter sido removidas ou expiradas. Verifique se a sua conta ainda possui acesso com o parceiro e se o token de acesso é válido.',
	unknown_error: 'Erro desconhecido',
	possible_cause: 'Possível causa',
	template_error_envio:
		'Ocorreu uma falha no envio do template para um ou mais números da lista. Verifique o template utilizado e os números de destino inseridos.',
	template_edited:
		'Não foi possível enviar o template. Ele foi editado recentemente e ainda aguarda aprovação da Meta. Recomendamos criar um novo template para acelerar o processo de verificação.',
	invalid_tokens:
		'O token do canal parece ser inválido. Isso geralmente acontece quando o número foi cadastrado em outra plataforma. Tente adicionar o número novamente ou entre em contato com o suporte.',
	using_test_tokens: 'Utilize os tokens "live" ao invés dos tokens "test".',
	legacy: 'Plano Legacy',
	basic: 'Plano Basic',
	pro: 'Plano Pro',
	total_recurring: 'Total recorrente',
	renew_in: 'Renovação em',
	pro_numbers: 'Números PRO',
	basic_numbers: 'Números BASIC',
	subscription_not_found:
		'<b>Assinatura não encontrada.</b> {br} Ative sua assinatura para continuar usando o aplicativo.',

	// SubscriptionView
	my_subscription: 'Gerenciar minha assinatura',
	subscription_now: 'Ativar assinatura agora',
	update_payment: 'Atualizar cartão de crédito',
	renew_failed: '<b>Não foi possível renovar sua assinatura.</b>',
	trial_expired:
		'<strong>Seu período de testes terminou.</strong> {br} Ative a sua assinatura para continuar utilizando o aplicativo.',

	// Help Good Habits
	help_good_habits: 'Boas Práticas',
	good_habits: 'Boas práticas de uso PowerZap',
	good_habits_description:
		'Algumas boas práticas no dia a dia, podem ser fundamentais para evitar o bloqueio/banimento de um número. Ações simples, mas que podem fazer uma grande diferença. {link}',
	know_more: 'Saiba mais.',
	alert_good_habits:
		'Aprenda boas práticas de uso do PowerZap para evitar bloqueio/banimento do seu número. {link}',
	help_good_habits_title: '<b> Boas Práticas de Uso </b>',
	help_good_habits_intro:
		'Algumas boas práticas no dia a dia, podem ser fundamentais para evitar o bloqueio/banimento de um número. Ações simples, mas que podem fazer uma grande diferença.',
	help_good_habits_1:
		'1. Tenha seu perfil no WhatsApp Business preenchido (com foto de perfil, endereço, descrição, site, e-mail de contato, etc.).',
	help_good_habits_2: '2. Evite enviar mensagens para números que não estão em seus contatos.',
	help_good_habits_3:
		'3. Personalize as mensagens com informações do destinatário. Se não for possível, use atributos aleatórios para diferenciar cada mensagem.',
	help_good_habits_4:
		'4. Incentive o destinatário a interagir com seu número, especialmente se você souber que ele não possui seu número na agenda.',
	help_good_habits_5: '5. Ofereça a opção para o destinatário não receber mais mensagens.',
	help_good_habits_6: '6. Envie mensagens APENAS para clientes que autorizaram o recebimento.',
	help_good_habits_7: '7. Evite conteúdo de mensagens com linguagem imprópria.',
	help_good_habits_8: '8. Evite enviar mensagens automáticas com links e imagens.',
	help_good_habits_9:
		'9. Use com cautela as automações do Bitrix24 para envios controlados e moderados.',
	help_good_habits_10:
		'10. Para receber mensagens com promoções, recomende que o destinatário adicione o número da empresa aos contatos e envie uma mensagem dizendo "quero promoções". Essa ação reduz significativamente o risco de bloqueios, já que, com o número na agenda e iniciando a conversa, os botões de bloqueio e denúncia de spam não aparecem.',
	help_good_habits_11:
		'11. Personalize as mensagens com dados do destinatário (ex.: Nome, Sobrenome, Apelido, etc.) para evitar que todas as mensagens fiquem exatamente iguais.',
	help_good_habits_12:
		'12. Sempre forneça uma opção para o destinatário deixar de receber mensagens. Por exemplo: "Digite 2 para não receber mais essas mensagens". Isso permite remover os números que não desejam mais receber das listas de envio.',
	help_ban_title: '<b> Ações em caso de Bloqueio/Banimento </b>',
	help_ban_intro_1:
		'Em caso de bloqueio/banimento, é importante seguir as ações de recuperação e para evitar novos bloqueios/banimentos.',
	help_ban_intro_2:
		'Para recuperar um número bloqueado/banido, entre em contato com o WhatsApp (Meta) para solicitar o desbloqueio através dos seguintes canais de contato:',
	help_link: 'Link de contato',
	help_email: '- E-mails: {email1}, {email2}',
	help_ban_intro_3: '<b> Solicitação via Link: </b>',
	help_ban_item_1: '1. {link} para enviar a solicitação à equipe do WhatsApp.',
	help_ban_link: 'Entre neste link',
	help_ban_item_2:
		'2. Informe o número do telefone banido, adicione um endereço de e-mail para a resposta e selecione a opção "Web e Computador".',
	help_ban_item_3: '3. Na mensagem de solicitação você pode utilizar o template abaixo:',
	help_ban_item_3_1:
		"“Our company's number has been banned from WhatsApp and we don't understand why.We evaluated the messages sent and were unable to understand what led to the ban.How can we retrieve our number and normalize our customer service? Thanks!",
	help_ban_item_3_2: 'Att NOME_DA_SUA_EMPRESA, Brazil.”',
	help_ban_item_3_3: '<b> *OBS.: Substitua o NOME_DA_SUA_EMPRESA pelo nome da sua empresa. </b>',
	help_ban_item_4:
		'4. Ao clicar em avançar, na próxima página você clicará no botão de "Enviar Pergunta".',
	help_ban_item_4_1:
		'Prontinho, pós envio da solicitação o WhatsApp acusa o recebimento via e-mail imediatamente, realizando o desbloqueio imediatamente ou em até 3 dias úteis. A resposta do WhatsApp chegará no e-mail cadastrado.',
	help_ban_item_4_2: '<b> Solicitação via Email: </b>',
	help_ban_item_4_3:
		'1. Envie um e-mail para {email1}. Se não houver resposta após 72 horas, envie para {email2}.',
	help_ban_item_4_4:
		'2. No título do e-mail, use algo como "Questão sobre WhatsApp" ou "Questão sobre banimentos". No corpo do e-mail, utilize o seguinte template:',
	help_ban_item_4_5:
		'“O número da nossa empresa ( +55 xx xxxxxxxxx) foi banido do WhatsApp e não entendemos o porquê. Avaliamos as mensagens enviadas e não conseguimos entender o que levou ao banimento. Como podemos recuperar nosso número e normalizar nosso atendimento? Obrigado! Att NOME_DA_SUA_EMPRESA, Brasil.”.',
	help_ban_conn: 'Para conectar um novo número no PowerZap, atente-se aos seguintes pontos:',
	help_ban_conn_1: '1. Evite vincular o novo número ao mesmo CPF/CNPJ.',
	help_ban_conn_2:
		'2. Utilize o número anterior no aparelho e WhatsApp Web para enviar e receber mensagens e "aquecer" o número.',
	help_ban_conn_3: '3. Evite usar o mesmo aparelho.',
	help_ban_conn_4: '4. Limpe a fila do número antes de conectar o aparelho.',
	help_ban_conn_5: '5. Evite envios em massa inicialmente.',
	help_ban_conn_6: '6. Não envie mensagens para quem não autorizou o envio.',
	help_ban_conn_7: '7. Evite utilizar linguagens passivo-agressivas.',
	help_ban_info: 'Para obter mais informações clique aqui.',

	// Help Widget
	help_widget: 'Widgets',
	help_widget_title: '<b> Criação de Widgets </b>',
	help_widget_intro:
		'Capture instantaneamente o contato dos visitantes do seu site! Com o Botão de WhatsApp da Kory, você abre as portas para engajar visitantes interessados diretamente em suas ofertas. E a melhor parte? A instalação é simplificada, levando apenas 2 minutos!',
	help_widget_1:
		'Acesse o {link} e siga as instruções para criar o seu botão de WhatsApp personalizado.',
	help_widget_link_text: 'site do gerador',
	help_widget_2:
		'Preencha o formulário com os dados que devem ser exibidos no widget e indique o número de WhatsApp que deseja associar a ele. Em seguida, clique no botão "Criar botão de WhatsApp".',
	help_widget_3:
		'Prontinho, seu botão de WhatsApp foi criado! Agora basta clicar no botão "Copiar código" e colar o código gerado em seu site Bitrix24, Wordpress ou qualquer outra plataforma de sua escolha.',
	help_widget_4: '<b> Tutorial de integração do widget a uma página WordPress: </b>',
	help_widget_5: '<b> Tutorial de integração do widget a um site Bitrix24: </b>',
	help_widget_6: '<b> Tutorial de integração do widget a uma página ReactJS: </b>',
	help_alert_video: 'Infelizmente, o seu navegador não é compatível com a reprodução de vídeos.',
	help_widget_btn: 'CRIAR WIDGET',

	upgrade_subscription: 'Atualizar assinatura agora',
	upgrade_subscription_text: 'Atualize sua assinatura para usar o PowerZap.',
	warning_maximum_file_size: 'O arquivo possui tamanho superior a 100MB.',
	warning_header_image: 'Por favor, carregue uma imagem para prosseguir.',
	view_header_document: '📄 Visualizar documento',

	// Help MessageBird
	help_MessageBird_title: 'MessageBird (API Oficial)',
	help_MessageBird_1:
		'Para configurar nosso conector junto ao MessageBird é interessante começar pela tela do MessageBird.',
	help_MessageBird_2: 'Acesse sua conta no MessageBird e selecione a aba <b>Developers</b>',
	help_MessageBird_3: 'Em seguida, <b>API Acess</b> e em seguida <b>Add acess Key</b>',
	help_MessageBird_4: 'Dê um nome e selecione a opção <b>Live</b>',
	help_MessageBird_5: 'Com a chave gerada, selecione <b>Show key</b>',
	help_MessageBird_6: 'Copie a <b>Key</b> (chave)',
	help_MessageBird_7: 'No nosso APP, adicione um dispositivo',
	help_MessageBird_8: 'Nomeie e escolha a API <b>MessageBird</b>',
	help_MessageBird_9: 'E adicione Token no campo indicado',
	help_MessageBird_10:
		'Voltando para a tela do MessageBird selecione a aba <b>Chanels</b> no campo indicado',
	help_MessageBird_11:
		'Escolha canal do Whatsapp e caso não tenha o canal, basta criar um novo canal para o Whatsapp',
	help_MessageBird_12:
		'Faça o <b>scan do QR Code</b> com o aplicativo do Whatsapp ou envie a mensagem mostrada para o número indicado.',
	help_MessageBird_13: 'Copie o Channel ID',
	help_MessageBird_14: 'Cole na API Whatsapp no campo indicado.',
	help_MessageBird_15:
		'Na aba <b>Channels</b> do Messagebird acesse a área de Whatsapp e em <b>My Channels</b> copie o <b>Template Namespace</b> do canal desejado',
	help_MessageBird_16: 'Cole a informação no campo indicado',
	help_MessageBird_17: 'Voltando para a tela do MessageBird selecione editar',
	help_MessageBird_18:
		'E copie o número e cole no número de telefone dentro da API Whatsapp (o número do integrador deve ser Idêntico ao do integrador).',
	help_MessageBird_19: 'Salve e feito!',
	help_MessageBird_20: 'Seu app está configurado.',
	help_MessageBird_21: 'Agora basta vinculá-lo à um canal aberto.',

	// Help automation
	help_automation_title: 'Automações',
	help_automation_1:
		'Para utilizar automações no PowerZap, entre no menu de automações no funil que deseja adicionar a regra de automação e selecione o <b>ícone</b> apresentado abaixo:',
	help_automation_2: 'Selecione a opção "Criar" na aba Regras de automação e gatilhos.',
	help_automation_3:
		'Selecione a opção "Outros" e clique em "Adicionar" no item <b>[PowerZap WhatsApp API] Atividade WhatsApp</b>.',
	help_automation_4:
		'Coloque o número do seu dispositivo. <b>OBS: O número inserido deve ser o mesmo cadastrado no PowerZap</b>',
	help_automation_5: 'Selecione o campo do celular de destino pertencente ao lead/negócio.',
	help_automation_6: 'Coloque uma mensagem.',
	help_automation_7:
		'Selecione, opcionalmente, um arquivo para ser enviado junto a mensagem de automação. Para isto, é necessário criar no card de lead/negócio um campo do tipo arquivo e adicionar um arquivo (imagem, vídeo, documento) a este campo.',
	help_automation_8:
		'Preencha, opcionalmente, este campo com um link de um arquivo que esteja no seu Bitrix24.Drive, para ser enviado junto a mensagem de automação.',
	help_automation_9:
		'Para isto, é necessário realizar o upload de um arquivo (imagem, vídeo, documento) ao seu Bitrix24.Drive, selecionar este arquivo e clicar na opção "Compartilhar" e em seguida, na opção "Copiar link interno".',
	help_automation_10: 'Depois basta colar o link copiado no campo apresentado.',
	help_automation_11:
		'Selecione o usuário no Bitrix24 que será utilizado para executar as automações.',
	help_automation_12: 'Salve e feito!',
	help_automation_13: '<b>ENVIANDO TEMPLATES COM A API OFICIAL</b>',
	help_automation_14: 'Para enviar templates utilizando a API Oficial, utilize a seguinte sintaxe:',
	help_automation_15: '#template:NOME_DO_SEU_TEMPLATE',
	help_automation_16: '#params:PARAMETRO1,PARAMETRO2,PARAMETRO3',
	help_automation_17: 'Como o exemplo abaixo:',
	help_automation_18:
		'A mensagem resultante será o template que você escolheu, com os parâmetros definidos na automação:',
	help_automation_19:
		'Outra opção é adicionar o "ID do arquivo" a este campo, para isso é necessário criar a automação no modo "Criador de Fluxo" e adicionar os componentes "Informações do objeto do Drive" e "PowerZap WhatsApp API".',
	help_automation_20:
		'Em seguida, basta clicar nos três pontinhos ao lado do campo "ID/Link do arquivo Bitrix24.Drive" e selecionar a opção "Resultados Adicionais". Essa tela irá exibir o item "Informações do objeto do Drive", é necessário clicar sobre o item e escolher o atributo "ID".',
	help_automation_21:
		'Dessa forma, o campo será preenchido com o ID do arquivo selecionado no componente "Informações do objeto do Drive".',
	help_automation_22: '<b>Como enviar templates com localização via automação</b>',
	help_automation_23:
		'Para enviar um template com localização pela automação, siga os passos abaixo:',
	help_automation_24:
		'1. Abra o Google Maps e pesquise o endereço desejado e copie o link completo que aparece na barra de endereços do navegador.',
	help_automation_25:
		'2. Na automação, cole esse link logo após a sintaxe #location: no campo da mensagem.',
	help_automation_26:
		'3. O template será enviado automaticamente com a localização correta para o usuário.',

	// Help campaign
	help_campaign_title: 'Campanha de Marketing',
	help_campaign_1:
		'Você pode utilizar o serviço de Campanhas de Marketing do Bitrix24 para fazer envio de mensagens de WhatsApp para a sua base de clientes através do PowerZap.',
	help_campaign_2:
		'Para realizar esse tipo de envio, você precisa acessar a seção "Marketing" do seu Bitrix24, entrar na aba "Campanhas" e clicar em "CRIAR CAMPANHA", selecionando a opção "Campanha SMS".',
	help_campaign_3:
		'Selecione um filtro para o segmento que você deseja enviar e crie um segmento de destinatários.',
	help_campaign_4:
		'Os seus números cadastrados no aplicativo PowerZap aparecerão como opção para envio no campo "Enviar:". Escolha o número pelo qual você deseja enviar a campanha, edite a mensagem e salve. Você poderá enviar a campanha assim que o Bitrix24 terminar de preparar o seu segmento.',
	help_campaign_5:
		'No vídeo abaixo você pode conferir um passo a passo da criação de uma campanha de SMS:',
	help_campaign_6:
		'<b>Alguns detalhes importantes devem ser observados para este tipo de ação!</b>',
	help_campaign_7:
		'1 - O envio ocorre para um destinatário a cada 1 minuto aproximadamente. Isso é necessário para que não ocorra bloqueio do WhatsApp pela identificação de envio em massa. Planeje as suas campanhas considerando este tempo.',
	help_campaign_8:
		'2 - Apesar do espaçamento entre o envio das mensagens, o bloqueio ainda pode ocorrer caso uma parcela dos destinatários denunciem o envio como SPAM. Faça campanhas para uma base que deseja receber suas comunicações.',
	help_campaign_9:
		'3 - Novas campanhas utilizando o mesmo número só serão enviadas após o termino do envio da campanha anterior. Você pode utilizar números diferentes para fazer envios paralelos.',
	help_campaign_10:
		'Caso você queira cancelar o envio da campanha, basta acessar o aplicativo e ir na aba "Campanhas de Marketing". Nessa tela serão listados todos os números de telefone cadastrados, quantas mensagens ainda estão na fila para serem enviadas e a opção "Limpar Fila".',
	help_campaign_11:
		'Ao clicar na opção "Limpar Fila" você deve confirmar a ação clicando em "Sim". <b>Vale lembrar:</b> que ao escolher essa opção você estará excluindo todas as mensagens de campanhas na fila que estão associadas ao número de telefone selecionado.',
	help_campaign_12:
		'Em seguida, o aplicativo irá exibir uma mensagem de sucesso e os números que ainda possuem mensagens de campanhas na fila para serem enviadas.',
	help_button_title: 'Botões de Resposta Rápida',
	help_button_0: 'Respostas Rápidas: Facilidade e Agilidade no Atendimento',
	help_button_1:
		'Atualmente, os botões são compatíveis apenas com o número Pro e com o 360Dialog, utilizando o número da API Basic.',
	help_button_2:
		'Com os botões de resposta rápida, fica muito mais simples interagir com nossas mensagens. Você pode enviar perguntas com opções de resposta já prontas, e basta o destinatário tocar no botão correspondente que sua resposta será enviada automaticamente, sem necessidade de digitar.',
	help_button_3:
		'Você pode usar os botões predefinidos ou criar seus próprios botões de resposta rápida. Confira abaixo o passo a passo para criar e utilizar seus botões de resposta rápida:',
	help_button_4: 'Veja como utilizar os botões de resposta rápida diretamente no chat:',
	help_button_5:
		'Confira abaixo o passo a passo para utilizar os botões de resposta rápida em automações:',
	help_button_6:
		'Reforçando que, nos vídeos, todos os envios de botões em chat ou automação seguem o padrão #btn:Nome do Botão. Portanto, tudo que for colocado depois de #btn: será considerado o nome do botão de resposta rápida.',
	help_button_7:
		'Na API do 360, o envio pelo card ainda é realizado via template, enquanto o uso dos botões está disponível apenas no chat.',

	// Help Audio Transcription
	help_audio_transcription_title: 'Transcrição de Áudio',
	help_audio_transcription_0: 'Como ativar a Transcrição de Áudio de Mensagens Recebidas',
	help_audio_transcription_1:
		'A funcionalidade de transcrição converte automaticamente mensagens de áudio recebidas em texto. Está disponível para números Pro e números integrados via 360Dialog com a API Basic.',
	help_audio_transcription_2: '✅ Pré-requisitos:',
	help_audio_transcription_3: 'Ter um número Pro ou um número ativo via 360Dialog.',
	help_audio_transcription_4:
		'Possuir uma chave de API válida da OpenAI para realizar as transcrições.',
	help_audio_transcription_5: 'Passo a passo para ativar a transcrição:',
	help_audio_transcription_6: 'Acesse o menu de edição do número',
	help_audio_transcription_7: 'Vá até o menu "Configurações adicionais" do número desejado.',
	help_audio_transcription_8: 'Habilite a opção de Transcrição de Áudio',
	help_audio_transcription_9: 'Localize a seção "Transcrição de áudio".',
	help_audio_transcription_10: 'Clique em "Ativada" para habilitar a funcionalidade.',
	help_audio_transcription_11: 'Insira sua chave da OpenAI',
	help_audio_transcription_12:
		'Ao ativar a funcionalidade, será solicitado que você insira o token (chave de API) da sua conta OpenAI.',
	help_audio_transcription_13: 'Insira o token e salve as alterações.',
	help_audio_transcription_14: '✅ Pronto!',
	help_audio_transcription_15:
		'As mensagens de áudio recebidas por este número agora serão transcritas automaticamente em tempo real.',
	help_audio_transcription_16: '🔎 Monitoramento de Status',
	help_audio_transcription_17:
		'O status da transcrição para cada número pode ser visualizado diretamente no painel de controle do Powerzap.',
	help_audio_transcription_18:
		'Você pode ativar ou desativar a funcionalidade a qualquer momento para cada número individual.',
	help_audio_transcription_19: 'ℹ️ Observações',
	help_audio_transcription_20:
		'A funcionalidade ainda não está disponível para as outras plataformas de integração (MessageBird, Twilio, uTalk e Meta).',
	help_audio_transcription_21:
		'Certifique-se de que sua chave da OpenAI possui créditos suficientes e acesso à funcionalidade de transcrição de áudio (como o modelo whisper-1).',
	help_audio_transcription_22: '🔈 Formatos de áudio suportados:',

	// PowerZap
	number_disconnected: 'Seu número está desconectado, reinicie a sessão clicando no botão abaixo',
	number_disconnected_alert: 'Número desconectado: Faça a leitura do QR Code de',
	meta_disconnected_alert_title: 'Canal desconectado',
	meta_disconnected_alert_body:
		'Este número está desconectado do WhatsApp oficial. Reconecte sem perder configurações ou histórico.',
	meta_disconnected_alert_cta: 'Reconectar',
	disconnect: 'Desconectar',
	connected_number: 'Número conectado:',
	starting_container:
		'Sua sessão está sendo iniciada, esse procedimento pode demorar em torno de 5 minutos. Aproveite esse momento para se hidratar, te avisaremos quando seu QR Code estiver disponível.',
	session_start_alert: 'Sua sessão do PowerZap foi iniciada, faça a leitura do QRCode!',
	reading_qrcode_message:
		'Após fazer a leitura do QR Code, aguarde o carregamento das informações sobre a sua sessão.',
	qrcode_polling_failed: 'Não foi possível atualizar o QR Code',
	qrcode_polling_failed_message:
		'Tivemos um problema para gerar um novo QR Code. Tente novamente ou use o método alternativo de conexão abaixo.',
	zapi_alternative_method_cta: 'Problemas para conectar? Use o método alternativo',
	zapi_alternative_method_error:
		'Não foi possível abrir o método alternativo de conexão. Tente novamente em instantes.',
	zapi_alternative_method_not_ready:
		'Sua conexão ainda está sendo preparada. Aguarde alguns instantes e tente novamente.',
	zapi_alternative_method_connected:
		'Conectado com sucesso! Aguarde alguns instantes para a confirmação final.',
	zapi_alternative_method_cancelled:
		'Método alternativo fechado sem concluir a conexão. Você pode tentar novamente quando quiser.',
	zapi_alternative_method_sdk_error:
		'Ocorreu um erro durante a conexão pelo método alternativo. Você pode tentar novamente.',
	zapi_alternative_method_expired:
		'Sua instância expirou. Entre em contato com o suporte para renovar.',
	start_session_failed: 'Falha ao iniciar a sessão',
	register_on_chat_switch: 'Enviar mensagem para o Chat do Bitrix24',
	register_on_chat_switch_alert:
		'<strong>Iniciar conversas a partir dessa funcionalidade poderá causar problemas com bots.</strong>',
	register_on_chat_switch_disabled:
		'É necessário ter uma conversa iniciada para habilitar esta funcionalidade.',
	register_on_chat_fail: 'Falha ao enviar mensagem para o chat do Bitrix24',
	retry_send_message_without_register: 'Enviando mensagem ao integrador, por fora do chat...',
	error_empty_channel_id: 'Não foi possível encontrar o canal aberto para o número selecionado',
	error_empty_dialog_id: 'Não foi possível encontrar um chat para entidade e número',
	confirm_set_number_on_pattern:
		'Identificamos que um número de destino está fora do novo padrão Brasil, que inclui o nono dígito. Deseja alterá-lo automaticamente e prosseguir?',

	// Help arquivos suportados
	supported_files_title: 'Envio de Arquivos',
	help_maximum_file_size_1:
		'O aplicativo PowerZap é uma plataforma que permite o envio e recebimento de mensagens de forma eficiente e confiável. No entanto, é importante destacar que o APP possui um <b>limite de envio de arquivos de até 100MB por transferência</b>. Essa política de limite de tamanho visa garantir a estabilidade e a velocidade do serviço, proporcionando aos usuários a melhor experiência possível durante o compartilhamento de documentos, fotos, vídeos e outros tipos de arquivos.',
	help_maximum_file_size_2:
		'Caso você precise enviar arquivos maiores, recomendamos dividir o conteúdo em partes menores ou explorar outras opções de compartilhamento para garantir a entrega bem-sucedida do material.',
	help_maximum_file_size_3: '<b>É importante se atentar aos avisos:</b>',
	help_maximum_file_size_4:
		'Aviso exibido ao tentar enviar um arquivo de tamanho superior a 100MB pelo card.',
	help_maximum_file_size_5:
		'Aviso exibido ao tentar enviar um arquivo de tamanho superior a 100MB pelo bate-papo do Bitrix24.',
	help_maximum_file_size_6:
		'Aviso exibido ao tentar enviar um arquivo de tamanho superior a 100MB pela automação.',

	// Br24 API (zapi)
	radio_zapi: 'Integrador padrão do aplicativo',
	zapi_description_1:
		'Faça a leitura do QR Code para conectar seu número de WhatsApp ao aplicativo.',
	zapi_description_2:
		'Para conectar você precisa abrir, no seu aparelho, o aplicativo do WhatsApp, no canto superior esquerdo clicar nos três pontinhos e acessar "Aparelhos Conectados".',
	meta_description: 'Para conexão via API Oficial, acesse o <link>Guia Completo</link>.',

	// Installation Errors and Messages
	handler_imconnector: 'Falha ao registrar o Conector no Contact Center',
	handler_bizproc_activity: 'Falha ao registrar atividade de Fluxo de Automação',
	handler_bizproc_robot: 'Falha ao registrar automação',
	register_event: 'Falha ao registrar evento',
	register_placement: 'Falha ao registrar placement',
	handler_imconnector_message: `O Conector do Contact Center é a conexão entre o aplicativo API WhatsApp Integration e as conversas do Bitrix24.
    Recomendado solicitar ao administrador reinstalar o aplicativo e caso problema persista entre em contato com o suporte.`,

	handler_bizproc_activity_message:
		'Este erro pode impedir a criação da opção de utilizar o aplicativo em seu fluxo de automação. Isso pode ocorrer caso o seu plano do Bitrix24 não contemple o uso de automações.',
	handler_bizproc_robot_message:
		'Este erro pode impedir a utilização de automações para envio de mensagens de WhatsApp. Este erro pode ocorrer caso o seu plano do Bitrix24 não contemple o uso de automações.',
	register_event_message:
		'Este erro impede o recebimento pelo aplicativo de um evento que ocorre no Bitrix24.',
	register_placement_message:
		'Este erro impede o registro do aplicativo em uma aba do seu Bitrix24, impossibilitando o uso na aba determinada.',
	installation_errors_found: 'Ocorreram falhas na sua instalação, saiba mais:',
	error_found: 'Erro encontrado',

	// PricingCard Component
	billing_cycle: 'mês',
	basic_tag_label: '',
	basic_description: 'Apenas o conector de API Oficial.',
	basic_feature_1: 'Conector de API Oficial',
	basic_feature_2: 'Número aprovado pelo Facebook',
	basic_feature_3: 'Mensagens ilimitadas',
	basic_feature_4: 'Histórico de Conversas no CRM',
	basic_feature_5: 'Múltiplos agentes por número de WhatsApp (opcional)',
	basic_button_label: 'Adquirir Basic',
	pro_tag_label: 'Recomendado',
	pro_description: 'Pacote completo do conector/integrador PowerZap.',
	pro_feature_1: 'Conector + Integrador PowerZap',
	pro_feature_2: 'Sem necessidade de templates',
	pro_feature_3: 'Envio e recebimento de áudios',
	pro_feature_4: 'Histórico de Conversas no CRM',
	pro_feature_5: 'Simplicidade para configuração de novos números',
	pro_button_label: 'Adquirir Pro',
	current_plan_tag: 'Plano atual',
	upgrade_basic_plan: 'Atualizar BASIC',

	// CurrentPlan Component
	current_plan_title: 'Plano atual',
	current_plan_name: 'Basic',
	current_plan_billing_cycle: 'Valor',
	current_plan_next_invoice: 'Próxima fatura',
	current_plan_features: 'Funcionalidades do Plano Basic',
	current_plan_feature1: 'Integrador uTalk*',
	current_plan_feature2: 'Integrador MessageBird',
	current_plan_feature3: '20/mês mensagens trocadas',
	current_plan_utalk_deprecated: '* Integração será descontinuada em breve',

	// CustomizingPlan Component
	customize_plan_pro_title: 'Plano Pro | Personalize seu plano',
	customize_plan_pro_description: 'Já inclui um número PowerZap e um número API Oficial.',
	customize_plan_basic_title: 'Plano Basic | Personalize seu plano',
	customize_plan_basic_description: 'Já inclui um número API Oficial.',
	customizing_plan_billing_period: 'Período de pagamento',
	customizing_plan_pay_month: 'Mensalmente',
	customizing_plan_pay_year: 'Anualmente',
	customizing_plan_months_free: '~ 2 meses grátis',
	customizing_plan_additional_numbers: 'Números adicionais',
	customizing_plan_total: 'Total',
	customizing_plan_cancel_button: 'Cancelar',
	customizing_plan_confirm_button: 'Confirmar',
	api_official: 'API Oficial',
	success_title: 'Seu plano foi atualizado para {planName} com sucesso.',
	success_subtitle: 'A próxima fatura será enviada no próximo ciclo de cobrança.',
	error_400: 'Não é possível atualizar uma assinatura com plano ANUAL',
	error_500: 'Não foi possível atualizar sua assinatura',
	error_subtitle: 'Por favor, entre em contato com o suporte.',
	go_to_dashboard_button: 'Voltar ao Painel',

	PAID: 'ASSINADO',
	PENDING: 'EXPIRADO',
	TRIAL: 'TRIAL',
	CANCELED: 'CANCELADO',
	CANCELLATION_PROCESS: 'CANCELANDO',

	// numberitem Component
	validity_trial: 'Seu teste do integrador irá expirar em {validity}.',

	// marketing view
	marketing_cta_title: 'Campanhas de Marketing via WhatsApp!',
	topic1: 'Segmente suas campanhas para alcançar exatamente quem você deseja.',
	topic2: 'Envie suas mensagens na hora mais conveniente para seus clientes.',
	topic3: 'Envie campanhas com arquivos de mídia para um impacto visual mais forte e eficaz.',
	topic4:
		'Acompanhe os resultados e a eficiência de suas campanhas para melhora-las cada vez mais.',
	button_form: 'Registrar interesse',

	Form_input_1: 'Qual o principal objetivo com o uso das campanhas via WhatsApp?',
	Form_input_1_opcion: 'Selecione uma opção',
	Form_input_1_opcion_1: 'Aumentar o engajamento dos clientes',
	Form_input_1_opcion_2: 'Promover novos produtos ou serviços',
	Form_input_1_opcion_3: 'Informar sobre promoções e descontos',
	Form_input_1_opcion_4: 'Melhorar a comunicação e relacionamento com os clientes',
	Form_input_1_opcion_5: 'Obter feedback dos clientes',
	Form_input_1_opcion_6: 'Outros',
	Form_input_2: 'Por favor, especifique:',
	Form_input_3: 'Você já utiliza campanhas do WhatsApp?',
	confirmation_title: 'Interesse registrado!',
	confirmation_subtitle: 'Entraremos em contato em breve com mais informações.',

	Click_here_to_find_out_now: 'Clique aqui para conhecer agora',
	change_value:
		'⚠️ Comunicado importante - A partir do dia 1º de agosto, haverá uma alteração no valor dos nossos serviços!',
	promotional_value: 'Valor promocional até 31 de julho. Aproveite!',

	// permission view
	permission_title: 'Grupos de Permissões',
	new_group: 'Novo Grupo',
	group_name: 'Nome do Grupo',
	numbers: 'Números',
	users: 'Usuários',
	group_actions: 'Ações',
	create_group_success: 'O grupo de permissões foi criado!',
	create_group_error: 'Não foi possível criar o grupo de permissões',
	create_new_permission_group: 'Criar novo grupo de permissão',
	edit_new_permission_group: 'Editar novo grupo de permissão',
	i_permission_group_name: 'Nome do grupo de permissões',
	whatsapp_numbers: 'Número do WhatsApp',
	placeholder_group_name: 'Digite o nome do grupo',
	i_whatsapp: 'Número de WhatsApp conectado',
	placeholder_whats_app: 'Clique aqui e selecione o número',
	i_users: 'Usuários do seu portal',
	placeholder_users: 'Clique aqui e selecione o usuário',
	permission_deleted_notification: 'Tem certeza que deseja excluir esse grupo de permissões?',
	btn_delete_ok: 'Sim, desejo deletar',
	btn_delete_cancel: 'Cancelar',
	delete_group_success: 'Grupo de permissões excluído com sucesso!',
	delete_group_error: 'Não foi possível excluir o grupo de permissões',
	edited_group_success: 'Grupo de permissões editado com sucesso!',
	edited_group_error: 'Não foi possível editar o grupo de permissões',
	user_not_found: 'Nenhum usuário encontrado',
	permissions: 'Permissões',
	permissions_introduction:
		'A aba "Permissões" é o local central para administrar o acesso de usuários a cada número conectado em sua conta. Aqui, você encontrará as seguintes funcionalidades:',
	permissions_introduction_1:
		'<b>Lista de Grupos:</b> Visualize a lista de grupos de permissões já criados;',
	permissions_introduction_2:
		'<b>Criar Novo Grupo:</b> Crie facilmente um novo grupo de permissões para personalizar o acesso;',
	permissions_introduction_3:
		'<b>Editar Grupos Existentes:</b> Faça ajustes nos grupos de permissões conforme necessário;',
	permissions_introduction_4: '<b>Excluir Grupos:</b> Remova grupos que já não são necessários;',
	permissions_introduction_5:
		'Apenas os usuários com privilégios de administrador têm acesso a esta funcionalidade.',
	permissions_introduction_6: '<b>Benefícios dos Grupos de Permissões:</b>',
	permissions_introduction_7:
		'Uma vez que um grupo de permissões é criado, apenas os usuários adicionados a ele terão acesso às seguintes áreas e funcionalidades:',
	permissions_introduction_8: 'Painel de Controle;',
	permissions_introduction_9: 'Edição de Número;',
	permissions_introduction_10: 'Envio de Mensagens pelo Card CRM;',
	permissions_introduction_11:
		'Este recurso permite um controle mais preciso sobre quem pode interagir com os números conectados e realizar ações específicas.',
	permissions_tutorial:
		'Na tela de "Permissões", você terá acesso aos grupos de permissões relacionados a cada número cadastrado no PowerZap.',
	permissions_tutorial_1:
		'<b>Grupo Padrão:</b> O grupo "default" é criado automaticamente e inclui a lista de números conectados e todos os usuários do seu portal Bitrix24:',
	permissions_tutorial_2: '<b>Criando um Novo Grupo:</b>',
	permissions_tutorial_3:
		'Na tela principal, clique em "Novo Grupo" para criar um novo grupo de permissões:',
	permissions_tutorial_4:
		'Ao clicar no botão "Novo Grupo", você será redirecionado para a tela de criação de um novo grupo:',
	permissions_tutorial_5: 'Preencha o formulário com os seguintes campos:',
	permissions_tutorial_6: '<b>Nome do Grupo:</b> Digite o nome do grupo que deseja criar:',
	permissions_tutorial_7:
		'<b>Número do WhatsApp:</b> Selecione o número conectado que deseja associar ao novo grupo:',
	permissions_tutorial_8: '<b>Usuários:</b> Selecione os usuários que farão parte desse grupo:',
	permissions_tutorial_9:
		'Você pode escolher a opção "Todos" para adicionar todos os usuários do seu portal a esse novo grupo ou selecionar usuários individualmente:',
	permissions_tutorial_10:
		'Para facilitar a seleção de usuários, utilize a função de pesquisa. Digite o nome do usuário e ele aparecerá na lista para seleção:',
	permissions_tutorial_11:
		'Depois de preencher os campos, clique em "Salvar" para criar o novo grupo:',
	permissions_tutorial_12:
		'Se desejar, clique em "Voltar" para retornar à tela principal da aba "Permissões":',
	permissions_tutorial_13: '<b>Editando um Grupo de Permissões:</b>',
	permissions_tutorial_14:
		'Você pode editar as informações de um grupo de permissões existente. Para fazer isso, clique no botão "Editar" na coluna de ações do grupo que deseja editar:',
	permissions_tutorial_15:
		'Você será redirecionado para a página de edição, onde encontrará um formulário preenchido com os dados do grupo que deseja editar:',
	permissions_tutorial_16:
		'Edite o nome do grupo, o número do WhatsApp e os usuários conforme necessário:',
	permissions_tutorial_17: 'Clique em "Salvar" para confirmar as alterações:',
	permissions_tutorial_18:
		'Se preferir, clique em "Voltar" para retornar à tela principal da aba "Permissões":',
	permissions_tutorial_19: '<b>Excluindo um Grupo de Permissões:</b>',
	permissions_tutorial_20:
		'Você também pode excluir um grupo de permissões existente. Para fazer isso, clique no botão "Excluir" na coluna de ações do grupo que deseja deletar:',
	permissions_tutorial_21:
		'Após clicar em "Excluir", uma confirmação será exibida na tela para garantir que você deseja deletar o grupo:',
	permissions_tutorial_22:
		'Se desejar cancelar a exclusão, clique em "Cancelar", e o grupo não será deletado:',
	permissions_tutorial_23:
		'Se tiver certeza de que deseja excluir o grupo, clique em "Sim, desejo deletar", e o grupo será removido com sucesso:',
	permissions_tutorial_24:
		'Esperamos que as orientações facilitem o gerenciamento de grupos de permissões. Em caso de dúvidas adicionais, entre em contato com nosso suporte.',
	permissions_alert: 'Aprenda a criar grupos de permissões no PowerZap! {link}',
	notifiable_users_alert:
		'Agora você pode definir usuários que deverão receber notificações importantes sobre o app! {link}',
	click_here: 'Clique aqui.',
	notify_click_here: 'Clique aqui para configurar',
	notifiable_save_success: 'Usuários a serem notificados salvo com sucesso',
	notifiable_save_error: 'Houve um erro ao salvar as configurações',
	notifiable_tooltip:
		'Defina os usuários que receberão notificações importantes sobre a aplicação.',
	notifications: 'Notificações',
	notified_users: 'Usuários Notificados',
	notifiable_widget_alert: 'NOVIDADE 🎉🎉 Crie widgets de WhatsApp de forma simplificada. {link}',
	notify_click_here_widget: 'Clique aqui para saber mais.',
	sendings_by_type: 'Envios por tipo',
	total_messages: 'Total:',
	received: 'Recebidas',
	crm: 'CRM',
	automacao: 'Automações',
	campanha: 'Campanhas',
	chat: 'Bate-papo',
	percentage_evolution_tooltip: 'Evolução comparada a média diária do mês anterior',
	percentage_total_tooltip: 'Proporção do total de mensagens trocadas',
	percentage_sent_tooltip: 'Proporção do total de envios',
	select_month: 'Selecione o mês',
	insights: 'INSIGHTS',
	insights_unavailable: 'Este recurso não está disponível para o domínio atual',
	chart_messages_total_title: 'Total de Mensagens',
	chart_sent_and_received_title: 'Mensagens Enviadas e Recebidas',
	chart_sending_types_title: 'Automações, Campanhas e Áudios',
	chart_messages_total: 'Total de mensagens',
	chart_messages_sent: 'Enviadas',
	chart_messages_received: 'Recebidas',
	chart_automation: 'Automações',
	chart_campaign: 'Campanha',
	chart_audio: 'Áudio',
	marketing_form_title: 'Quer ser um dos primeiros a saber mais sobre essa novidade?',
	insight_form_already_submitted_title: 'Seu interesse na feature de Insights já foi registrado.',
	insight_form_already_submitted_subtitle:
		'Assim que ela estiver disponível, você será um dos primeiros a experimentá-la.',
	insight_form_error_title: 'Houve um erro ao enviar o formulário.',
	insight_form_error_subtitle: 'Por favor, recarregue a página e tente novamente',
	insight_form_error_message: 'Se o problema persistir, entre em contato com o nosso suporte.',
	insight_form_success_title: 'Feito!',
	insight_form_success_subtitle: 'Seu interesse foi repassado ao nosso time',
	insight_form_success_message: 'Em breve entraremos em contato com você.',
	insight_form_title: 'Gostaria de visualizar o seu Dashboard?',
	insight_form_subtitle: 'Preencha o formulário para solicitar informações',
	insight_form_message:
		'Prometemos não utilizar suas informações de contato para enviar qualquer tipo de SPAM.',
	insight_form_name: 'Nome*',
	insight_form_email: 'Email*',
	insight_form_whatsapp: 'WhatsApp',
	insight_form_send: 'Enviar',
	insight_form_required_field: 'Este campo é obrigatório',
	widget_feature: 'Gerador de botão de WhatsApp',
	widget_feature_description:
		'Crie botões personalizados para adicionar ao seu site e capturar leads automaticamente. {link}',
	widget_create_button: 'Criar Widget para Sites',
	widget_table_title: 'Interações com Widgets',
	widget_table_title_tooltip:
		'Dados coletados a partir de interações com Widgets de números conectados ao seu PowerZap.',
	widget_url: 'Site do Widget',
	widget_url_tooltip: 'Url do site onde o widget foi adicionado.',
	widget_number: 'Número',
	widget_redirects: 'Redirecionamentos',
	widget_redirects_tooltip:
		'Quantidade de vezes que um cliente clicou no widget e foi redirecionado ao seu número de WhatsApp.',
	widget_table_download: 'Baixar dados',
	chart_widget_title: 'Interações Com Widgets Por Mês',
	chart_clicks: 'Cliques',
	chart_redirects: 'Redirecionamentos',
	create_widget_button: 'Criar Widget',
	create_widget_button_tooltip:
		'Crie um botão para adicionar ao seu site e permitir que os visitantes o contatem através do WhatsApp.',
	objective_with_the_application: 'Principal objetivo com o aplicativo',
	select_objective: 'Selecione',
	option_increase: 'Aumentar as vendas',
	option_improve: 'Aumentar a eficiência do atendimento ao cliente',
	option_automate: 'Automatizar comunicações',
	option_whatsapp: 'Realizar campanhas de marketing via WhatsApp',
	option_extract: 'Extrair insights de interações com clientes e leads',
	option_centralize: 'Centralizar comunicações em uma única plataforma',
	option_other: 'Outro',
	input_name: 'Digite seu nome',
	input_email: 'Digite seu email',
	input_website: 'Digite o endereço do seu site',
	input_phone_label: 'Telefone',
	input_phone: 'Digite o número do seu telefone',
	virtual_number_title: 'Adicionar número virtualizado',
	virtual_number_tooltip:
		'Com o número virtualizado, não há necessidade de utilizar smartphones ou emuladores para cada número. A conexão é totalmente virtual.',
	virtual_number_form: 'Interessado em adicionar número virtualizado (sem smartphone)?',
	virtual_number_form_subtitle:
		'Preencha o formulário a seguir para nossa equipe lhe passar mais detalhes sobre o seu funcionamento.',
	virtual_number_input_1: 'Nome',
	virtual_number_input_1_placeholder: 'Digite seu nome',
	virtual_number_input_2: 'Email',
	virtual_number_input_2_placeholder: 'Digite seu email',
	virtual_number_input_3: 'WhatsApp',
	virtual_number_input_3_placeholder: 'Digite o número do seu WhatsApp',
	virtual_number_input_4: 'Quantidade de números virtualizados',
	virtual_number_input_4_placeholder: 'Selecione a quantidade de números virtualizados',
	virtual_number_send: 'Enviar',
	virtual_number_option_1: '1 número',
	virtual_number_option_2: '2 números',
	virtual_number_option_3: '3 números',
	virtual_number_option_4: '4 números',
	virtual_number_request: 'Digite o número virtual ',
	virtual_number_error_1: 'Houve um erro ao enviar o formulário',
	virtual_number_error_2:
		'Por favor, recarregue a página e tente novamente. Se o problema persistir, entre em contato com o nosso suporte.',
	virtual_number_success_1: 'Feito!',
	virtual_number_success_2:
		'Seu interesse foi repassado ao nosso time. Em breve entraremos em contato com você.',
	btn_loading_trial: 'Enviando os dados, aguarde...',
	virtual_number_name_error_1: 'Por favor, insira seu nome',
	virtual_number_name_error_2: 'O nome deve conter apenas letras',
	virtual_number_email_error_1: 'Por favor, insira seu email',
	virtual_number_email_error_2: 'Por favor, insira um email válido',
	virtual_number_whats_error_1: 'Por favor, insira seu WhatsApp',
	virtual_number_whats_error_2: 'O WhatsApp deve conter apenas números',
	virtual_number_quantity_error: 'Por favor, selecione a quantidade de números virtualizados',
	virtual_number_virtualized_error: 'Por favor, insira o número de WhatsApp a ser virtualizado',
	form_trial_website_error: 'Por favor, insira o website da empresa',
	form_trial_country_error: 'Por favor, selecione o seu país',
	form_trial_phone_error_1: 'Por favor, insira seu telefone',
	form_trial_phone_error_2: 'O telefone deve conter apenas números',
	form_trial_objective_error: 'Por favor, selecione o principal objetivo com o aplicativo',
	help_360_dialog_1: '360dialog (API Oficial)',
	help_360_dialog_2: 'Como conectar sua conta 360dialog ao Bitrix24',
	help_360_dialog_3:
		'Para configurar nosso conector junto ao 360dialog você pode iniciar pelo próprio PowerZap. Confira no vídeo a seguir como configurar a integração e enviar suas primeiras mensagens pelo Bitrix24:',
	help_360_dialog_4: 'Seu navegador não suporta a tag de vídeo.',
	help_360_dialog_5: 'Já possui uma conta 360dialog e gostaria de solicitar a troca de parceiro?',
	help_360_dialog_6: 'Siga este guia de troca de parceiro',
	help_360_dialog_7: ' e, caso necessário, informe o ID de parceiro da Br24: {partner}.',
	help_360_dialog_8: 'Tutorial detalhado',
	help_360_dialog_9: 'Como conectar um número de WhatsApp 360dialog no Bitrix24:',
	help_360_dialog_10:
		'Para conectar um novo número, basta clicar em "Adicionar novo número" na seção de números Basic',
	help_360_dialog_11:
		'Logo que abrir o pop-up selecione a opção API “360dialog” e clique em "Adicionar novo número”',
	help_360_dialog_12:
		'Após isso, você notará que uma nova janela será aberta sobreposta ao PowerZap. Nela você criará sua conta 360dialog preenchendo os campos do formulário ou, se já possuir conta 360dialog, bastará entrar na conta clicando em “Log In” no topo da janela.',
	help_360_dialog_13:
		'Caso você já tenha uma conta na 360dialog contratada diretamente com eles, você pode solicitar ao suporte da 360dialog a alteração do seu plano, indicando a contratação via parceiro 360dialog (PowerZap - Br24), recebendo assim um desconto no preço do plano.',
	help_360_dialog_14: 'Para maiores informações sobre a precificação praticada pela 360dialog',
	help_360_dialog_15: ' acesse este link.',
	help_360_dialog_16:
		'Obs.: utilizando o Chrome como navegador, você pode traduzir as etapas clicando com botão direito do mouse e selecionando a opção de tradução para Português. A partir de agora mostraremos as páginas traduzidas em Português.',
	help_360_dialog_17:
		'Na próxima etapa, será necessário informar o status atual do número do WhatsApp que você deseja adicionar.',
	help_360_dialog_18: 'Se o seu número estiver conectado à API do WhatsApp Business',
	help_360_dialog_19:
		'Após selecionar a opção e clicar em “Confirme os detalhes do número” prossiga digitando o número de telefone que você deseja adicionar e valide as informações necessárias para poder seguir.',
	help_360_dialog_20:
		'Na próxima etapa você precisará concluir a inscrição incorporada da Meta, basta seguir o passos a passo.',
	help_360_dialog_21:
		'Após concluir a inscrição incorporada você verá uma janela com a logo do Facebook, onde deverá dar continuidade',
	help_360_dialog_22:
		'Após seguir na etapa anterior, preencha as informações solicitadas e siga pelas próximas 4 etapas.',
	help_360_dialog_23:
		'Obs.: Caso o número a ser vinculado esteja vinculado a outro integrador (ex.: Twilio), será necessário primeiramente desvinculá-lo deste integrador para depois seguir na etapa a seguir.',
	help_360_dialog_24:
		'Agora, basta seguir com a autorização do aplicativo de parceiro, onde o parceiro é a Br24.',
	help_360_dialog_25:
		'Após a autorização do aplicativo de parceiro basta aguardar alguns segundos. Neste momento, será enviado uma comunicação para a aplicação, que por sua vez vai adicionar o novo número no seu portal.',
	help_360_dialog_26:
		'Assim que a mensagem de sucesso aparecer, basta fechar a janela e recarregar a página do PowerZap.',
	help_360_dialog_27:
		'⚠️ Para enviar suas mensagens via API Oficial Meta pelo PowerZap, você precisa primeiramente validar estas mensagens no 360dialog. Estas mensagens validadas/a validar são chamadas de “templates” (modelos). Para isso, basta logar na 360dialog e seguir o ',
	help_360_dialog_28: 'passo a passo de validação de modelos.',
	help_360_dialog_29:
		'Se o seu número NÃO estiver conectado à API do WhatsApp Business mas sim em uma conta pessoal',
	help_360_dialog_30:
		'Caso seu número esteja conectado à uma conta pessoal do WhatsApp, você precisará desconectar seu número à conta pessoal para migrar para uma conta WhatsApp Business API. Para isso, basta clicar em ',
	help_360_dialog_31: '"Como desconectar um número de uma conta pessoal do WhatsApp” ',
	help_360_dialog_32: 'e seguir o passo a passo.',
	help_360_dialog_33:
		'Após isso, será necessário voltar à esta etapa e selecionar a opção “Não, este número não está conectado a uma conta pessoal do WhatsApp”.',
	help_360_dialog_34:
		'Se o seu número NÃO estiver conectado à API do WhatsApp Business e à uma conta pessoal',
	help_360_dialog_35: 'Caso seu número não atenda a nenhuma das duas opções, você precisará ',
	help_360_dialog_36: 'conectar seu número à API do WhatsApp Business em sua conta Meta.',
	help_360_dialog_37: 'Após isso, será necessário voltar à esta janela e seguir conforme ',
	help_360_dialog_38: 'este passo a passo.',
	help_360_dialog_39: 'Templates',
	help_360_dialog_40:
		'É necessário um modelo de mensagem para que a Empresa inicie uma nova conversa com o seu contato. Isto é necessário caso não tenha havido interação entre ambos anteriormente ou se a última mensagem enviada pelo utilizador tiver mais de 24h. Para mais detalhes, ',
	help_360_dialog_41: 'clique aqui.',
	help_360_dialog_42:
		'Após a validação, os templates devem estar disponíveis para envio via PowerZap (pelo card e automação).',
	help_360_dialog_43: 'Envio manual:',
	help_360_dialog_44:
		'Para configuração de automação, é necessário inserir o nome do template seguido de “#template:”. Você pode também personalizar a mensagem com informações cadastradas nos cards. Para isso, basta informar os campos a serem utilizados, conforme exemplo a seguir:',
	help_360_dialog_45: 'Ficou com alguma dúvida sobre o 360dialog?',
	help_360_dialog_46: 'Entre em contato com a equipe de suporte da 360dialog pelo site ',
	help_360_dialog_47: 'https://www.360dialog.com/contact ',
	help_360_dialog_48: 'ou pelo e-mail support@360dialog.com',
	help_360_dialog_49: 'Ajuda 360dialog',
	help_360_dialog_50: 'Ainda precisa de ajuda?',
	help_360_dialog_51: 'Contacte o suporte da 360dialog pelo site ',
	help_360_dialog_52: 'Conecte o 360dialog',
	notification_checkbox: 'Receber notificação de número inválido.',
	info_notification1: 'Somente para numeros Pro.',
	info_notification:
		'Ao marcar essa opção, alguns usuários receberão notificações caso seja enviada uma mensagem para um número inválido através de um número pro.',
	info_notification_2:
		'Envio pelo card: Receberão a notificação o responsável pelo card, a pessoa que está enviando e as pessoas registradas nessa lista.',
	info_notification_3:
		'Envio de automação: Será enviado para o responsável pelo card e para as pessoas nessa lista.',
	info_notification_4: 'Envio de campanha: Somente quem está nessa lista receberá a notificação.',
	help_360_dialog_53: 'Criando/aprovando templates:',
	help_360_dialog_54: 'Acesso ao Painel da 360dialog:',
	help_360_dialog_55:
		'No painel da 360dialog, localize a seção de "Templates". Aqui, você poderá criar novos templates de mensagem, que são necessários para iniciar conversas de categorias como marketing, utilidade ou autenticação.',
	help_360_dialog_56: 'Criação de um novo template:',
	help_360_dialog_57: 'Clique em "Create new template" ou "Criar novo template".',
	help_360_dialog_58:
		'Ao iniciar a criação de um template, você deve fornecer detalhes como o nome do template, o idioma da mensagem, e a categoria da conversa (marketing, utilidade ou autenticação).',
	help_360_dialog_59:
		'Escolha uma categoria adequada com base no propósito da mensagem que será enviada (por exemplo, "marketing" para promoções ou "utilidade" para atualizações de pedido).',
	help_360_dialog_60: 'Definição do conteúdo da mensagem:',
	help_360_dialog_61:
		'Em seguida, será necessário preencher o corpo da mensagem com o texto do template. A mensagem pode conter variáveis dinâmicas, representadas por placeholders como {{1}}, {{2}}, que podem ser preenchidos posteriormente com informações específicas do cliente.',
	help_360_dialog_62:
		'A formatação do texto pode incluir parâmetros para personalização e opções de mídia, como adicionar botões, imagens, ou links que sejam úteis na comunicação com o cliente. ',
	help_360_dialog_63:
		'Depois de definir o conteúdo da mensagem, basta seguir adiante clicando em “Preview and submit”.',
	help_360_dialog_64: 'Template preview (Pré-visualização do template):',
	help_360_dialog_65:
		'Antes de enviar o template para aprovação, utilize a função Template Preview para revisar como a mensagem será exibida no WhatsApp do destinatário.',
	help_360_dialog_66:
		'Esse recurso permite visualizar o layout, a formatação do texto e a inserção correta das variáveis. Além disso, você pode verificar a disposição de botões, imagens e outros elementos interativos que foram incluídos no template.',
	help_360_dialog_67: 'Validação do template:',
	help_360_dialog_68:
		'Uma vez enviado, o status do template mudará para "Pending", indicando que está aguardando aprovação.',
	help_360_dialog_69:
		'Quando aprovado, o status do template será alterado para "Approved", e você poderá começar a utilizá-lo em suas campanhas ou comunicações.',
	help_360_dialog_70:
		'Caso o template seja rejeitado, você receberá uma justificativa, como a necessidade de ajustes no conteúdo.',
	openai_token_required: 'Chave da API OpenAI é obrigatória para habilitar a transcrição de áudio',
	openai_token_invalid:
		"Formato inválido da chave da API OpenAI. Deve começar com 'sk-' e ter pelo menos 48 caracteres",
	audio_transcription_tooltip:
		'Forneça sua chave de API da OpenAI para que o PowerZap transcreva automaticamente as mensagens de áudio recebidas em texto.',
	rapid_reply_title: 'Botões de resposta rápida',
	new_button_placeholder: 'Novo botão...',
	select_options_to_continue: 'Selecione as opções para continuar.',
	confirm: 'Confirmar',
	call: 'Ligar',
	no_thanks: 'Não, obrigado',
	i_want: 'Eu quero',
	no: 'Não',
	rapid_reply_tooltip: 'Selecione ou crie botões para estimular respostas rápidas e objetivas.',
	files_with_buttons: 'Envio de arquivos com botões',
	files_with_buttons_tooltip:
		'Envio de arquivos com botões suporta imagens e vídeos, outros tipos de arquivos não são suportados e não funcionarão corretamente.',
	invalid_number: 'Um dos números informados é inválido.',

	help_meta_connect: 'Como conectar',
	help_meta_title: 'Evite o bloqueio do seu número',
	help_meta_description:
		'Para evitar que seu número seja bloqueado pela Meta durante a integração, siga este checklist antes de continuar:',
	help_meta_item_1: 'Utilize exclusivamente a API Oficial da Meta',
	help_meta_item_1_description:
		'Seu número não pode estar conectado em nenhuma plataforma via API não oficial, incluindo número Pro do Powerzap .',
	help_meta_item_2: 'Realize a verificação da empresa na Meta',
	help_meta_item_2_description: '<link> Fazer verificação agora </link>',
	help_meta_item_3: 'Adicione um método de pagamento válido na Meta',
	help_meta_item_3_description: '<link>Adicionar método de pagamento </link>',
	help_meta_item_4: 'Tenha ao menos um modelo de mensagem aprovado',
	help_meta_item_4_description: '<link>Criar modelo de mensagem</link>',
	help_meta_info:
		'Para mais detalhes, acesse o <link>Guia Completo com passo a passo</link> da integração de API Oficial Meta no Powerzap.',
	help_meta_btn: 'Avançar',
	help_meta_confirm_checkbox:
		'Confirmo que já cumpri todos os itens acima e entendo que seguir sem atender ao checklist pode resultar no bloqueio do número pela Meta.',

	// SURVEY
	survey_send_response_button: 'Responder',
	survey_answered_title: 'Essa pesquisa já foi respondida!',
	survey_answered_description:
		'Fique de olho: assim que tivermos novidades, você será um dos primeiros a saber. 🚀',
	survey_modal_close_button: 'Fechar',
	survey_modal_discard_button: 'Descartar',
	survey_modal_discard_tooltip: 'Se descartar, esta pesquisa não voltará a aparecer.',
	survey_modal_redisplay_button: 'Lembrar-me depois',
	survey_modal_alert_required_fields: '* Campos obrigatórios',
	survey_input_required_error: 'Campo obrigatório',
	survey_helper_text_input_1: 'Selecione uma opção',
	survey_helper_text_input_2: 'Selecione pelo menos uma opção',
	survey_helper_max_selections_1: 'Marque apenas uma opção',
	survey_helper_max_selections_2: 'Marque até {maxSelections} opções',
	survey_feedback_send_event_ignored:
		'Reexibiremos a pesquisa em {redisplayInDays} {redisplayInDaysText}.',
	survey_feedback_send_event_discarded: 'Você descartou permanentemente a pesquisa.',
	survey_feedback_send_event_error: 'Erro ao registrar evento.',
	survey_feedback_send_response_error: 'Erro ao enviar a resposta da pesquisa.',
	survey_feedback_send_response_success: 'Obrigado por responder nossa pesquisa!',

	cta_kory_dashboard_title:
		'<highlight>Conectar</highlight> seu WhatsApp \n no Bitrix24 <b>nunca foi tão fácil</b>.',
	cta_kory_dashboard_cta: 'Conheça nosso novo App.',

	cta_powerbot_campaign_title:
		'Campanhas atraem conversas. \n Automação ajuda a transformar \n conversas em oportunidades.',
	cta_powerbot_campaign_subtitle:
		'Conecte campanhas de marketing com \n qualificação automática no <b>Powerbot.</b>',

	cta_kory_insights_title:
		'Evoluímos o controle de \n dados para oferecer ainda \n <b>mais insights no Kory Chat.</b>',

	cta_powerbot_permissions_title: 'Seu time cresce. <b>Seu atendimento \n precisa acompanhar.</b>',
	cta_powerbot_permissions_title_large:
		'Seu time cresce.\n <b>Seu atendimento \n precisa acompanhar.</b>',
	cta_powerbot_permissions_subtitle:
		'Ganhe mais escala com padronização \n usando bots e IA no <b>Powerbot.</b>',
	cta_powerbot_permissions_subtitle_large:
		'<b>Ganhe mais escala</b> com \n padronização <b>usando bots \n e IA</b> no Powerbot.',

	migrate_kory_alert_title: 'Suas automações do PowerZap continuam funcionando no Kory One.',
	migrate_kory_alert_description:
		'Basta manter conectado no Kory One o mesmo número que você utilizava nas automações do PowerZap, a migração acontece automaticamente e nada é perdido.',
	migrate_kory_card_migrate_title: 'Kory One',
	migrate_kory_card_migrate_description:
		'Migre suas automações do PowerZap para o Kory One em segundos.',
	migrate_kory_card_migrate_tooltip: 'Copia as automações do PowerZap e as recria no Kory One.',
	migrate_kory_card_migrate_button: 'Migrar agora',
	migrate_kory_card_revert_title: 'Voltar para PowerZap',
	migrate_kory_card_revert_description: 'Reverte a operação para o PowerZap se necessário.',
	migrate_kory_card_revert_tooltip: 'Desfaz a migração e restaura as automações no PowerZap.',
	migrate_kory_card_revert_button: 'Reverter',
	migrate_kory_confirm_title: 'Antes de migrar, leia com atenção',
	migrate_kory_confirm_description:
		'Para que suas automações continuem funcionando normalmente após a migração, é importante seguir os passos abaixo:',
	migrate_kory_confirm_warning_title: 'Mantenha o PowerZap instalado após a migração.',
	migrate_kory_confirm_warning_text:
		'Mesmo sem uma assinatura ativa, suas automações do PowerZap continuarão funcionando normalmente no Kory One.',
	migrate_kory_confirm_success_text:
		'Nenhuma automação será perdida. Tudo continua funcionando normalmente, agora via Kory One.',
	migrate_kory_confirm_cancel: 'Cancelar',
	migrate_kory_confirm_ok: 'Entendi, migrar agora',
	migrate_kory_error_title: 'Erro na migração',
	migrate_kory_success_title: 'Migração concluída!',
	migrate_kory_success_description:
		'Suas automações já foram migradas para o Kory One. Se quiser confirmar, basta testar as automações normalmente.',
	migrate_kory_success_button: 'Entendido',
	migrate_kory_revert_success_title: 'Operação revertida com sucesso!',
	migrate_kory_revert_success_content: 'Suas automações foram restauradas para o PowerZap.',

	calls_export_tab_title: 'Exportar Ligações',
	calls_export_title: 'Exportar ligações em CSV',
	calls_export_description:
		'Baixa um CSV com as notificações de chamada (WhatsApp) registradas para todos os clientes.',
	calls_export_button: 'Baixar CSV',
};
